import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import "./v-item-dropdown.component.scss";

export interface IDropdownItem {
    selected: boolean;
}

@Component({
    selector: 'v-item-dropdown',
    template: require('./v-item-dropdown.component.html')
})
export class VItemDropdownComponent implements OnInit, OnChanges {

    @Input() open = false;
    @Output() openChange = new EventEmitter<boolean>();

    //@Input() items: IDropDownItem[];
    @Input() data: IDropdownItem[];
    @Input() selected: any;

    @Input() keydownListener: Subject<KeyboardEvent>;

    @Input() itemTemplate: TemplateRef<any>;
    @Input() ignoreClicksFrom: HTMLElement;

    @Output() itemClicked = new EventEmitter();
    @Output() closed = new EventEmitter<MouseEvent>();

    @ViewChild("dropDown", { read: ElementRef }) dropDown: ElementRef<HTMLElement>;

    itemToSelect: any;
    private selectedIndex = -1;
    private subscription = new Subscription();

    constructor() {
    }

    ngOnInit(): void {
        this.subscribeToParentKeyPress();
        this.setSelectedIndex();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            // If dropdown list has changed, automatically select the first result
            this.selectedIndex = 0; 
        }

        if (this.open) {
            this.scrollToSelected();
        }

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    itemClick(item: any, event: MouseEvent) {
        event?.stopPropagation();

        this.itemClicked.emit(item);
        this.open = false;
    }

    onClosed($event: MouseEvent) {
        this.open = false;
        this.openChange.emit(this.open);
        this.closed.emit($event);
        this.setSelectedIndex();
    }

    // ---

    private scrollToSelected(iterationCount = 5, className = "selected") {
        // Scroll selected item into view
        if (!this.selected && !this.data?.some(d => d.selected) && !this.itemToSelect) {
            return;
        }

        var children = this.dropDown.nativeElement.getElementsByClassName(className);

        if (children.length == 0) {
            setTimeout(() => {
                this.scrollToSelected(iterationCount, className);
            });

            return;
        }

        var selectedChild = children[0] as HTMLElement;
        var parent = selectedChild.parentElement;

        // Validate we have a scrollbar, if not retry
        if (iterationCount > 0 && parent.scrollHeight > parent.clientHeight) {
            setTimeout(() => {
                this.scrollToSelected(iterationCount - 1, className);
            });

            return;
        }

        // Bring child into view
        parent.scrollTop = selectedChild.offsetTop;

    }
    private subscribeToParentKeyPress(): void {
        if (!this.keydownListener) {
            return;
        }

        this.subscription.add(this.keydownListener?.subscribe(keyEvent => {
            if (keyEvent.key.length == 1 || keyEvent.key == "Backspace") {
                // key is alphanumeric meaning a search term is being entered and the data is going to change
                this.selectedIndex = -1;
                return;
            }

            switch (keyEvent.key) {
                case "ArrowDown":
                case "ArrowUp":
                    this.handleArrowPress(keyEvent);
                    break;
                case "Enter":
                    this.handleEnterPress(keyEvent);
                    break;
            }
        }))
    }

    private handleArrowPress(keyEvent: KeyboardEvent): void {
        if (keyEvent.key == "ArrowDown" && this.selectedIndex < (this.data.length - 1)) {
            this.selectedIndex++;

        }

        if (keyEvent.key == "ArrowUp" && this.selectedIndex > 0) {
            this.selectedIndex--;
        }

        this.itemToSelect = this.data[this.selectedIndex];

        this.scrollToSelected(undefined, "highlighted");

    }

    private handleEnterPress(keyEvent: KeyboardEvent): void {
        this.itemClick(this.itemToSelect, null);
        this.onClosed(null);
    }

    private setSelectedIndex(): void {
        this.selectedIndex = this.data?.findIndex(item => item.selected);
    }
}
